import { Link, graphql } from "gatsby"

import Img from "gatsby-image"
import Layout from "../components/layout"
import profilePicFallback from "../../content/assets/profile-pig.jpg"
import React from "react"
import SEO from "../components/seo"
import interviewData from "../../data/interviews"
import newsletterData from "../../data/newsletters"

class Index extends React.Component {
  render() {
    const { data } = this.props
    const siteTitle = data.site.siteMetadata.title
    const posts = data.allMarkdownRemark.edges

    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO title="Peter Elbaum | Software Engineer, YouTuber, Writer" />
        <div className="container">
          <div className="flex intro">
            <h1 className="intro-text">Hi, I'm Peter</h1>
            {data.profilePic?.childImageSharp?.fixed ? (
              <Img className="index-profile" fixed={data.profilePic.childImageSharp.fixed} alt="Peter Elbaum" />
            ) : (
              <img className="index-profile" src={profilePicFallback} alt="Peter Elbaum" />
            )}
          </div>
          <p className="description">I write code, make things, and direct a summer camp. Welcome to my home on the internet!</p>
          <p className="description">On this site I sometimes write about code, self-improvement, entrepreneurship, personal finance, and other things. I used to make videos on <a rel="noopener noreferrer" target="_blank" href="https://www.youtube.com/channel/UCPcyffOFc7YGyDgqmvZJs7Q">my YouTube channel</a>, but I've hit pause on it for now.</p>
          <p className="description">I also used to write a newsletter, <Link to="/newsletter">Elbaum's World</Link>. It was one email a month with updates from self-employment, plus links to my new articles, tweets, videos and other favorite things. I now write a different newsletter called <a rel="noopener noreferrer" target="_blank" href="https://campoperations.com">The Referral Rundown</a>.</p>
          <p className="descripton">These days, I'm mostly focused on building <a rel="noopener noreferrer" target="_blank" href="https://camptree.org">Camp Tree</a>, which I acquired in April 2025.</p>
          <p className="description"><Link to="/about">Find out more about me here →</Link></p>
          {/* <Subscribe hideExplainer /> */}
        </div>
        <h2>Recent appearances:</h2>
        { interviewData.interviews.map((interview, i) => {
          return i < 4 ?
            <article key={i}>
              <header>
                <h3 className="blog-title">
                  <a rel="noopener noreferrer" target="_blank" style={{ boxShadow: `none` }} href={interview.url}>
                    {interview.title}
                  </a>
                </h3>
                <p>{interview.source}</p>
              </header>
            </article>
            : null
        })}
        {/* Article Seciont */}
        <h2>Read the latest articles:</h2>
        { posts.map((post, i) => {
          const title = post.node.frontmatter.title || post.node.fields.slug
          return i < 3 ?
          <article key={post.node.fields.slug}>
            <header>
              <h3 className="blog-title">
                <Link style={{ boxShadow: `none` }} to={post.node.fields.slug}>
                  {title}
                </Link>
              </h3>
              <p>{post.node.frontmatter.date}</p>
            </header>
          </article>
          : null
        })}
        <Link to="/articles"><div className="button">View All</div></Link>
        {/*  */}
        <h2>Browse the latest newsletter:</h2>
        { newsletterData.newsletters.map((post, i) => {
          const title = post.title
          return i < 3 ?
            <article key={i}>
              <header>
                <h3 className="blog-title">
                  <a rel="noopener noreferrer" target="_blank" style={{ boxShadow: `none` }} href={post.link}>
                    {title}
                  </a>
                </h3>
                <p>{post.date}</p>
              </header>
            </article>
            : null
        })}
        <Link to="/newsletter"><div className="button">View All</div></Link>
      </Layout>
    )
  }
}

export default Index

export const pageQuery = graphql`
  query {
    profilePic: file(relativePath: { eq: "profile-pig.jpg" }, sourceInstanceName: { eq: "assets" }) {
      childImageSharp {
        fixed(width: 100, height: 100) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            tags
          }
        }
      }
    }
  }
`
